import connect from './connect';

export { SignUpScreen } from './SignUpScreen';

export default connect;
